import React, { type FC, type PropsWithChildren, type HTMLAttributes } from 'react';

import { expValEquals } from '@confluence/feature-experiments';

import { CoverPictureWrapperCss } from './EditorPageCoverPictureWrapperCss.tsx';
import { CoverPictureWrapperStyled } from './EditorPageCoverPictureWrapperStyled.tsx';

export type CoverPictureWrapperProps = PropsWithChildren<
	HTMLAttributes<HTMLDivElement> & {
		hasCoverPicture: boolean;
		isUploadingPicture: boolean;
		isReadOnly?: boolean;
		isFixedWidthImageOption?: boolean;
		isSmartSpaceOverview?: boolean;
		smartSpaceOverviewHeight?: number;
		width?: number;
		dynamicCoverImageHeight?: number;
	}
>;

export const CoverPictureWrapper: FC<CoverPictureWrapperProps> = (props) => {
	if (expValEquals('confluence_page_cover_picture_css_migration', 'isEnabled', true)) {
		return <CoverPictureWrapperCss {...props} />;
	}
	return <CoverPictureWrapperStyled {...props} />;
};
